export const permissions = [
  "dashboard.read", "users.read", "users.write", "users.ban", "devices.manage",
  "plans.manage", "codes.manage", "channels.read", "channels.write", "streams.manage",
  "content.manage", "events.manage", "ads.manage", "notifications.send", "analytics.read",
  "support.manage", "transactions.read", "settings.manage", "admins.manage", "logs.read",
] as const;

export type Permission = (typeof permissions)[number];

export function can(userPermissions: readonly string[], permission?: string): boolean {
  return !permission || userPermissions.includes(permission) || userPermissions.includes("*");
}
